import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor() {}

  setPrimaryAccent(primary: string, accent: string) {
    document.documentElement.style.setProperty('--primary-color', primary);
    document.documentElement.style.setProperty('--accent-color', accent);

    // Optional: auto-set contrast colors
    document.documentElement.style.setProperty('--primary-contrast', '#fff');
    document.documentElement.style.setProperty('--accent-contrast', '#fff');
  }
}
